var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19386 15.09L5.71225 21.062C5.62876 21.3986 5.97809 21.6783 6.28822 21.5232L11.6367 18.849C11.8654 18.7346 12.1347 18.7346 12.3634 18.849L17.7119 21.5232C18.022 21.6783 18.3714 21.3986 18.2879 21.062L16.8062 15.0898C15.5524 16.2744 13.861 17.0006 12 17.0006C10.139 17.0006 8.44767 16.2745 7.19386 15.09Z",
    fill: "#B35F9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16ZM13.7845 12.4583C13.8356 12.4863 13.8912 12.5 13.9465 12.5C14.0193 12.5 14.0918 12.4764 14.1527 12.4291C14.2602 12.3464 14.3141 12.2064 14.2913 12.0679L13.9514 9.98953L15.3935 8.51788C15.4894 8.42002 15.524 8.27304 15.4831 8.13862C15.4421 8.00493 15.3326 7.90707 15.2003 7.88713L13.2052 7.58135L12.3134 5.68834C12.1951 5.43722 11.8049 5.43722 11.6866 5.68834L10.7948 7.58135L8.79974 7.88713C8.66743 7.90707 8.55788 8.00493 8.51693 8.13862C8.47598 8.27304 8.51063 8.42002 8.60653 8.51788L10.0486 9.98953L9.7087 12.0679C9.68595 12.2064 9.7395 12.3464 9.8473 12.4291C9.9544 12.5118 10.0972 12.5229 10.2155 12.4583L11.9998 11.4745L13.7845 12.4583Z",
    fill: "#7CB141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/Training.958d444888a7a5a61dca06d847326e29.svg";
export { ForwardRef as ReactComponent };